/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { v4 } from "../../common/miscellaneous/v4";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { isUserLoggedIn } from "../../payment/miscellaneous/parseCookie";
import { dispatchSignInInfoEvent } from "./dispatchSignInInfoEvent";
import { getExternalClientIdFromCookies } from "./getExternalClientIdCookie";
import { SignInInfo } from "./normalizeSigninResponse";
import { SigninResponseProxied } from "./signIn";

const headersWithClientId = new Headers();
headersWithClientId.append("Content-Type", "application/x-www-form-urlencoded");
headersWithClientId.append("X-Digikey-Request-Id", v4());

export function setSignInInfoTimeout(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  info: SignInInfo
): unknown {
  const tenSecondBuffer = 10_000;
  const msUntilExpires = info.expiresAt.getTime() - new Date().getTime();

  return setTimeout((): unknown => {
    const loggedIn = isUserLoggedIn(document.cookie); // Set by partner side using SDK

    if (!loggedIn) {
      return;
    } else {
      return fetchItJson<SigninResponseProxied, unknown>(
        "none",
        `${getPartnerPathnameClient(true)}/v1/oauth2/token`,
        {
          method: "POST",
          headers: headersWithClientId,
          body: new URLSearchParams({
            client_id:
              sessionStorage.getItem("MkHcClientId") ??
              getExternalClientIdFromCookies() ??
              "MISSING",
            grant_type: "refresh_token",
          }).toString(),
        }
      ).then(
        (
          // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
          result
        ) => {
          if (result.tag === "successful") {
            return dispatchSignInInfoEvent({
              tag: "not-normalized",
              info: result.parsed,
            });
          } else {
            return;
          }
        }
      );
    }
  }, msUntilExpires - tenSecondBuffer);
}
